<template>
  <div class="home">
    <!-- 英雄区域 -->
    <section class="hero">
      <div class="hero-content">
        <div class="container">
          <div class="hero-text">
            <div class="hero-badge">
              <span>🚀 创新驱动未来</span>
            </div>
            <h1 class="hero-title">
              打造
              <span class="highlight">智能化</span>
              企业解决方案
            </h1>
            <p class="hero-description">
              我们致力于为企业提供创新的数字化解决方案，通过先进的技术和专业的服务，
              帮助客户实现业务转型升级，提升运营效率，创造更大商业价值。
            </p>
            <div class="hero-stats">
              <div class="stat">
                <span class="stat-number">500+</span>
                <span class="stat-label">成功案例</span>
              </div>
              <div class="stat">
                <span class="stat-number">98%</span>
                <span class="stat-label">客户满意度</span>
              </div>
              <div class="stat">
                <span class="stat-number">7×24</span>
                <span class="stat-label">技术支持</span>
              </div>
            </div>
            <div class="hero-actions">
              <router-link to="/contact" class="btn btn-primary">
                <span>立即咨询</span>
                <i class="arrow">→</i>
              </router-link>
              <router-link to="/products" class="btn btn-secondary">
                <span>产品介绍</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 特色介绍 -->
    <section class="features section">
      <div class="container">
        <div class="section-title">
          <h2>为什么选择我们</h2>
          <p>专业、创新、可靠的企业服务提供商</p>
        </div>
        <div class="features-grid">
          <div class="feature-card" v-for="feature in features" :key="feature.id">
            <div class="feature-icon">{{ feature.icon }}</div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品服务 -->
    <section class="products section" style="background: #f8f9fa;">
      <div class="container">
        <div class="section-title">
          <h2>核心产品服务</h2>
          <p>为不同行业提供定制化的解决方案</p>
        </div>
        <div class="products-grid">
          <div class="product-card" v-for="product in products" :key="product.id">
            <div class="product-image">
              <div class="product-placeholder">{{ product.icon }}</div>
            </div>
            <div class="product-content">
              <h3 class="product-title">{{ product.title }}</h3>
              <p class="product-description">{{ product.description }}</p>
              <ul class="product-features">
                <li v-for="feature in product.features" :key="feature">{{ feature }}</li>
              </ul>
              <a href="#" class="product-link">了解更多 →</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据统计 -->
    <section class="stats section">
      <div class="container">
        <div class="stats-grid">
          <div class="stat-item" v-for="stat in stats" :key="stat.id">
            <div class="stat-number">{{ stat.number }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户案例 -->
    <section class="testimonials section" style="background: #f8f9fa;">
      <div class="container">
        <div class="section-title">
          <h2>客户反馈</h2>
          <p>听听我们客户的真实评价</p>
        </div>
        <div class="testimonials-grid">
          <div class="testimonial-card" v-for="testimonial in testimonials" :key="testimonial.id">
            <div class="testimonial-content">
              <div class="quote-icon">"</div>
              <p class="testimonial-text">{{ testimonial.content }}</p>
            </div>
            <div class="testimonial-author">
              <div class="author-avatar">{{ testimonial.avatar }}</div>
              <div class="author-info">
                <div class="author-name">{{ testimonial.name }}</div>
                <div class="author-position">{{ testimonial.position }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA区域 -->
    <section class="cta section">
      <div class="container">
        <div class="cta-content">
          <h2 class="cta-title">准备开始您的数字化转型之旅？</h2>
          <p class="cta-description">联系我们的专业团队，获取量身定制的解决方案</p>
          <div class="cta-actions">
            <router-link to="/contact" class="btn btn-primary">免费咨询</router-link>
            <a href="tel:400-123-4567" class="btn btn-secondary">致电咨询</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      features: [
        {
          id: 1,
          icon: '🚀',
          title: '创新技术',
          description: '采用最新的技术栈和架构设计，为客户提供前沿的解决方案。'
        },
        {
          id: 2,
          icon: '🛡️',
          title: '安全可靠',
          description: '完善的安全体系和稳定的系统架构，确保数据安全和业务连续性。'
        },
        {
          id: 3,
          icon: '⚡',
          title: '高效执行',
          description: '敏捷的开发流程和专业的项目管理，快速响应客户需求。'
        },
        {
          id: 4,
          icon: '🎯',
          title: '精准定制',
          description: '深入了解客户业务需求，提供个性化的定制服务。'
        }
      ],
      products: [
        {
          id: 1,
          icon: '💼',
          title: '企业管理系统',
          description: '全面的企业资源规划解决方案',
          features: ['财务管理', '人力资源', '供应链管理', '客户关系管理']
        },
        {
          id: 2,
          icon: '☁️',
          title: '云计算服务',
          description: '弹性可扩展的云基础设施',
          features: ['云服务器', '数据存储', '网络安全', '监控运维']
        },
        {
          id: 3,
          icon: '📊',
          title: '数据分析平台',
          description: '智能化的商业数据分析工具',
          features: ['实时分析', '可视化报表', '预测建模', '决策支持']
        }
      ],
      stats: [
        { id: 1, number: '500+', label: '成功案例' },
        { id: 2, number: '50+', label: '合作伙伴' },
        { id: 3, number: '98%', label: '客户满意度' },
        { id: 4, number: '7×24', label: '技术支持' }
      ],
      testimonials: [
        {
          id: 1,
          content: '合作非常愉快，项目按时交付，系统运行稳定，大大提升了我们的工作效率。',
          name: '张总',
          position: 'ABC科技有限公司 CEO',
          avatar: '👨‍💼'
        },
        {
          id: 2,
          content: '专业的技术团队，贴心的售后服务，是我们信赖的长期合作伙伴。',
          name: '李总',
          position: 'XYZ制造集团 CTO',
          avatar: '👩‍💼'
        },
        {
          id: 3,
          content: '数字化转型效果显著，ROI超出预期，强烈推荐给其他企业。',
          name: '王总',
          position: '123贸易公司 总经理',
          avatar: '👨‍💻'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* 英雄区域 */
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, var(--gray-900) 0%, var(--primary-dark) 60%, var(--primary-color) 100%);
  color: white;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 20%, rgba(124, 58, 237, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(30, 64, 175, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 40% 60%, rgba(6, 182, 212, 0.2) 0%, transparent 50%);
  pointer-events: none;
}

.hero::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(to right, 
    transparent, 
    rgba(255, 255, 255, 0.1), 
    transparent
  );
  transform: skewY(-1deg);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
}

.hero .container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
}

.hero-text {
  animation: fadeInUp 1s ease-out;
  max-width: 800px;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 0.75rem 1.5rem;
  border-radius: 2rem;
  margin-bottom: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.3s ease;
}

.hero-badge:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.hero-title {
  font-size: 4rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
}

.highlight {
  background: linear-gradient(135deg, #ffffff 0%, var(--accent-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline-block;
  position: relative;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.5) 0%, var(--accent-color) 100%);
  border-radius: 2px;
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

.hero-description {
  font-size: 1.25rem;
  line-height: 1.7;
  margin-bottom: 3rem;
  opacity: 0.9;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 400;
}

.hero-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  margin: 3rem 0;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: var(--radius-xl);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.stat {
  text-align: center;
  position: relative;
}

.stat::after {
  content: '';
  position: absolute;
  top: 50%;
  right: -1.5rem;
  width: 1px;
  height: 3rem;
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-50%);
}

.stat:last-child::after {
  display: none;
}

.stat-number {
  display: block;
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #ffffff 0%, var(--accent-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  font-size: 0.875rem;
  opacity: 0.8;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.hero-actions {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-top: 3rem;
}

.hero-actions .btn {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 2rem;
  border-radius: 3rem;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-width: 160px;
  justify-content: center;
}

.hero-actions .btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.hero-actions .btn:hover::before {
  left: 100%;
}

.hero-actions .btn-primary {
  background: rgba(255, 255, 255, 0.95);
  color: var(--primary-color);
  border: 2px solid transparent;
  box-shadow: var(--shadow-lg);
}

.hero-actions .btn-primary:hover {
  background: white;
  transform: translateY(-2px);
  box-shadow: var(--shadow-xl);
  color: var(--primary-dark);
}

.hero-actions .btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.hero-actions .btn-secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.8);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.arrow {
  font-style: normal;
  transition: transform 0.3s ease;
  font-size: 1.125rem;
}

.hero-actions .btn:hover .arrow {
  transform: translateX(4px);
}

/* 特色介绍 */
.features {
  background: var(--gray-50);
  position: relative;
}

.features::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(to right, 
    transparent, 
    rgba(30, 64, 175, 0.05), 
    transparent
  );
  transform: skewY(1deg);
  margin-top: -50px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 1rem;
}

.feature-card {
  background: white;
  padding: 2.5rem 2rem;
  border-radius: var(--radius-xl);
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--gray-200);
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--gradient-primary);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.feature-card:hover::before {
  transform: scaleX(1);
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-xl);
  border-color: var(--gray-300);
}

.feature-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  display: block;
}

.feature-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: 1rem;
}

.feature-description {
  color: var(--gray-600);
  line-height: 1.6;
  font-size: 1rem;
}

/* 产品服务 */
.products {
  position: relative;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2.5rem;
}

.product-card {
  background: white;
  border-radius: var(--radius-xl);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--gray-200);
  position: relative;
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-xl);
}

.product-image {
  height: 200px;
  background: var(--gradient-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.product-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.product-card:hover .product-image::before {
  left: 100%;
}

.product-placeholder {
  font-size: 4rem;
  color: white;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.product-content {
  padding: 2rem;
}

.product-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: 1rem;
}

.product-description {
  color: var(--gray-600);
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.product-features {
  list-style: none;
  margin-bottom: 2rem;
}

.product-features li {
  padding: 0.5rem 0;
  color: var(--gray-700);
  position: relative;
  padding-left: 1.5rem;
}

.product-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--success-color);
  font-weight: bold;
}

.product-link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
}

.product-link:hover {
  color: var(--primary-dark);
  gap: 0.75rem;
}

/* 数据统计 */
.stats {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: white;
  position: relative;
  overflow: hidden;
}

.stats::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(6, 182, 212, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 3rem;
  position: relative;
  z-index: 1;
}

.stat-item {
  text-align: center;
  padding: 2rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-xl);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-4px);
  background: rgba(255, 255, 255, 0.15);
}

.stat-item .stat-number {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #ffffff 0%, var(--accent-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-item .stat-label {
  font-size: 1rem;
  opacity: 0.9;
  font-weight: 500;
}

/* 客户案例 */
.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
}

.testimonial-card {
  background: white;
  padding: 2rem;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--gray-200);
  position: relative;
}

.testimonial-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--gradient-primary);
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
}

.testimonial-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.testimonial-content {
  margin-bottom: 1.5rem;
}

.quote-icon {
  font-size: 3rem;
  color: var(--primary-color);
  opacity: 0.3;
  margin-bottom: 1rem;
  font-family: serif;
}

.testimonial-text {
  font-size: 1.1rem;
  line-height: 1.6;
  color: var(--gray-700);
  font-style: italic;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.author-avatar {
  width: 3rem;
  height: 3rem;
  background: var(--gradient-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
}

.author-name {
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: 0.25rem;
}

.author-position {
  font-size: 0.875rem;
  color: var(--gray-600);
}

/* CTA区域 */
.cta {
  background: linear-gradient(135deg, var(--gray-900) 0%, var(--primary-dark) 100%);
  color: white;
  position: relative;
  overflow: hidden;
}

.cta::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(124, 58, 237, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(6, 182, 212, 0.2) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(30, 64, 175, 0.2) 0%, transparent 50%);
  pointer-events: none;
}

.cta-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.cta-title {
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.cta-description {
  font-size: 1.25rem;
  margin-bottom: 3rem;
  opacity: 0.9;
  line-height: 1.6;
}

.cta-actions {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.cta-actions .btn {
  padding: 1rem 2rem;
  border-radius: 3rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-width: 160px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cta-actions .btn-primary {
  background: white;
  color: var(--primary-color);
  box-shadow: var(--shadow-lg);
}

.cta-actions .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-xl);
  color: var(--primary-dark);
}

.cta-actions .btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.4);
}

.cta-actions .btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: white;
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }

  .hero-description {
    font-size: 1.125rem;
  }

  .hero-stats {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 1.5rem;
  }

  .stat::after {
    display: none;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
  }

  .hero-actions .btn {
    min-width: 200px;
  }

  .features-grid,
  .products-grid {
    grid-template-columns: 1fr;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  .testimonials-grid {
    grid-template-columns: 1fr;
  }

  .cta-title {
    font-size: 2rem;
  }

  .cta-description {
    font-size: 1.125rem;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-stats {
    padding: 1rem;
  }

  .stat-number {
    font-size: 2rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .cta-title {
    font-size: 1.75rem;
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/Home.vue